import { Directive, ElementRef, EventEmitter, NgZone, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[resizeObserver]'
})
export class ResizeObserverDirective implements OnInit, OnDestroy {
  @Output() resized = new EventEmitter<DOMRectReadOnly>();

  private observer?: ResizeObserver;

  constructor(private el: ElementRef, private zone: NgZone) {}

  ngOnInit() {
    this.zone.runOutsideAngular(() => {
      this.observer = new ResizeObserver(entries => {
        for (const entry of entries) {
          this.zone.run(() => this.resized.emit(entry.contentRect));
        }
      });
      this.observer.observe(this.el.nativeElement);
    });
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}
